import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

export const Container = styled.div``;

export const Title = styled.div`
  margin-block-end: 8px;

  font-weight: 700;
  font-size: 14px;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
`;

export const Icon = styled.img`
  inline-size: 160px;
  block-size: 47px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 136px;
    block-size: 40px;
  }
`;

export const StyledBaseLink = styled(BaseLink)`
  line-height: 0;
`;
